import React from 'react';
import { t } from 'Src/i18n';
import { PledgPrice } from './PledgPrice';

type Props = {
  isPaymentPage?: boolean;
  proposal?: Proposal;
  price: Price;
  iconClassname: string;
};

export const PledgFromPricing = ({ price, iconClassname }: Props) => (
  <div className="md:text-center">
    <span className="text-12">{t('booking.banking.paymentSchedule.fromPricing')}</span>
    <PledgPrice price={price.total.value} iconClassname={iconClassname} />
  </div>
);
